// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { CACHE_SIZE_UNLIMITED, enableIndexedDbPersistence, getFirestore } from "firebase/firestore"
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {

	apiKey: "AIzaSyAJzZIVMWnALc-RSg3fuDqMs27nKZAeerk",
  
	authDomain: "ilalc-owb-test.firebaseapp.com",
  
	projectId: "ilalc-owb-test",
  
	storageBucket: "ilalc-owb-test.appspot.com",
  
	messagingSenderId: "358050133615",
  
	appId: "1:358050133615:web:9dc2c527c099411ef73f9a",
  
	measurementId: "G-4YJWKFWHN4"
  
  };
  

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize database
export const db = getFirestore(app,{cacheSizeBytes: CACHE_SIZE_UNLIMITED});
enableIndexedDbPersistence(db)
	.then(()=>{
		console.log("enabled persistance");
	})
	.catch((err) => {
		if (err.code === 'failed-precondition') {
		} else if (err.code === 'unimplemented') {
		}
	});

// authentication
export const auth = getAuth();
